<template>
  <div class="container">
    <!-- <div class="apply-tab">
      <img @click="handleBack" style="width: 24px; height: 24px" src="@/assets/back.png" />
      <div>人员选择</div>
    </div>
    <div class="search">
      <van-search v-model="searchValue" placeholder="请输入人员名搜索"></van-search>
    </div> -->
    <!-- <CompanyList :data="list" /> -->
    <div class="confirm_btn">
      <div class="select_num">已选{{ selectedList.hasOwnProperty(`${status}`) ? selectedList[`${status}`].length : 0 }}/100</div>
      <div @click="confirm" class="btn">确定</div>
    </div>
    <van-popup v-model="show" class="approve_box" :close-on-click-overlay="false">
      <p class="approve_idea">转交意见</p>
      <van-field v-model="message" class="approve_text" type="textarea" placeholder="请输入转交意见" />
      <div>
        <van-field name="uploader" label="附件">
          <template #input>
            <van-uploader :after-read="file => afterRead(file)" :before-delete="file => beforeDelete(file)" v-model="approvalFileList" accept="*" :preview-image="false">
              <template>
                <div>
                  <img style="width: 1rem; height: 1rem" src="@/assets/join.svg" />
                </div>
              </template>
            </van-uploader>
          </template>
        </van-field>
        <div v-for="(i, index) in approvalFileList" :key="index" style="display: flex;justify-content: space-between;align-items: center;padding: 10px 16px">
          <div class="annex-name" @click="preview(i.url)">
            <img style="width: 22px;height: 20px;margin-right:8px" src="@/assets/file@2x.png" />
            <div style="display: flex;flex-direction: column">
              <div style="width: 5rem;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{ renderFileName(i) }}</div>
              <div>{{ formatSize(i.size, 2) }}</div>
            </div>
          </div>
          <div class="annex-button" @click="deleteFile(i)">删除</div>
        </div>
      </div>
      <div class="approve-btns">
        <span
          @click="
            show = false;
            approvalFileList = [];
            message = '';
          "
          style="height: 0.64rem;font-size: 0.43rem;color: #323233;"
        >
          取消
        </span>
        <span @click="handleApprove" style="height: 0.64rem;font-size: 0.43rem;color: #1584FF;">确认</span>
      </div>
    </van-popup>
    <router-view></router-view>
  </div>
</template>

<script>
import { handleArgee, upload } from '@/axios/services';
import { mapState, mapMutations } from 'vuex';
import { v4 as uuidv4 } from 'uuid';
import { Toast } from 'vant';
import VeiBanBridge from '@/utils/bridge';
import { formatSize } from '@/utils';
export default {
  components: {
    // CompanyList,
  },
  data() {
    return {
      list: [],
      show: false,
      message: '',
      approvalFileList: []
    };
  },
  computed: {
    ...mapState(['initialData', 'selectedList', 'status', 'approveInfo', 'fromApp'])
  },
  methods: {
    ...mapMutations(['clearSelectedList']),
    confirm() {
      if (this.status === 'transfer') {
        if (this.selectedList[`${this.status}`] && this.selectedList[`${this.status}`].length > 0) {
          // this.handleApprove()
          this.show = true;
        } else {
          Toast.fail('请先选择转交人');
        }
      } else {
        let billid = sessionStorage.billid; // 传回去后缀
        let billLinksType = sessionStorage.billLinksType;
        if (billid) {
          billid = JSON.parse(billid);
          this.$router.push({
            path: '/new-apply-form',
            query: billid
          });
        } else if (billLinksType) {
          let obj = {};
          obj.type = billLinksType;

          let draftFlagId = sessionStorage.draftFlagId;
          if (draftFlagId) {
            obj.id = draftFlagId;
          }

          this.$router.push({
            path: '/bills',
            query: obj
          });
        } else {
          this.$router.push('/new-apply-form');
        }
      }
    },
    preview(param) {
      window.location.href = 'jsToOc://fujianJump?url=' + param;
    },
    renderFileName(item) {
      let str = item?.url?.slice(item?.url?.lastIndexOf('.'));
      let name = item?.fileName || item?.name;
      return name + str;
    },
    formatSize(size, length) {
      return formatSize(size, length);
    },
    deleteFile(i) {
      this.approvalFileList = this.approvalFileList.filter(c => c.key !== i.key);
    },
    afterRead(file) {
      let content = file.file;
      let formData = new FormData();
      formData.append('file', content);
      const uuid = uuidv4();
      upload(formData).then(res => {
        this.approvalFileList = this.approvalFileList?.map(item => {
          if (Object.prototype.hasOwnProperty.call(item, 'file')) {
            return { ...res.data.data, key: uuid };
          } else {
            return item;
          }
        });
      });
    },
    beforeDelete(file) {
      this.approvalFileList = this.approvalFileList.filter(item => {
        if (Object.prototype.hasOwnProperty.call(file, 'file')) {
          return item.key !== file.file.key;
        } else {
          return item.key !== file.key;
        }
      });
    },
    async handleApprove() {
      const user = (await VeiBanBridge.getUserInfo()) || {};
      const config = {
        headers: {
          Token: user?.newToken
        }
      };
      const params = {
        linkId: this.approveInfo.currentApprover.linkId,
        memberId: this.approveInfo.currentApprover.memberId,
        instanceId: this.approveInfo.instanceId,
        approvalAction: '6',
        content: this.message,
        companyId: this.initialData.companyId,
        staffId: this.approveInfo.currentApprover.staffId,
        sort: this.approveInfo.currentApprover.sort,
        forwardStaffId: this.selectedList[`${this.status}`][0].staffId,
        files: this.approvalFileList
      };
      handleArgee(params, config).then(res => {
        if (res.data.code === 0) {
          this.show = false;
          this.message = '';
          this.handleBack();
        } else {
          Toast.fail(res.data.msg);
        }
      });
    },
    handleBack() {
      // window.location.href = "jsToOc://back";
      if (this.fromApp) {
        window.location.href = 'jsToOc://back';
      } else {
        this.$store.commit('setFromApp', true);
        this.$router.push('/workReport');
      }
    }
  }
};
</script>

<style lang="less" scoped>
.container {
  width: 100vw;
  // height: 100vh;
  overflow: auto;
  // padding-bottom: 68px;
  background: #f9f9f9;
  position: relative;
  .confirm_btn {
    width: 100%;
    height: 68px;
    background-color: #ffffff;
    box-shadow: 0px -2px 4px #efefef;
    position: fixed;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    z-index: 99;
    .select_num {
      font-family: Source Han Sans CN;
      color: #1584ff;
      font-size: 14px;
      line-height: 14px;
    }
    .btn {
      width: 120px;
      height: 44px;
      background-color: #1584ff;
      border-radius: 8px;
      box-shadow: 0px 2px 8px #80bcff;
      font-family: PingFang SC;
      font-weight: 500;
      color: #ffffff;
      font-size: 16px;
      line-height: 44px;
      text-align: center;
    }
  }
  .approve_box {
    width: 8.29rem;
    background: #ffffff;
    border-radius: 0.11rem;
    .approve_idea {
      width: 8.29rem;
      height: 0.96rem;
      font-size: 0.43rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #323233;
      line-height: 0.96rem;
      text-align: center;
      margin: 0;
      .approve_text {
        width: 6.5rem;
        height: 3.2rem;
        background: #ffffff;
        border-radius: 0.05rem;
        border: 0.01rem solid #dcdde0;
        margin: 0 auto;
      }
    }
    .approve-btns {
      width: 8.29rem;
      height: 1.28rem;
      background: #ffffff;
      border-radius: 0rem 0rem 0.11rem 0.11rem;
      display: flex;
      line-height: 1.28rem;
      justify-content: space-around;
    }
    .annex-name {
      display: flex;
      align-items: center;
    }
  }
}
.van-cell /deep/ .van-field__body {
  height: 100%;
}
.van-cell /deep/ .van-field__control {
  height: 100%;
}
.van-cell /deep/ .van-field__label {
  width: auto !important;
  color: #333;
  font-size: 16px;
  font-weight: 500;
}
.van-cell {
  display: flex;
  align-items: center;
}
.van-cell /deep/ .van-field__control--custom {
  display: flex;
  justify-content: flex-end;
}
.van-search {
  padding: 0;
}
</style>
